import { getToken } from '@chakra-ui/react';

import { theme as chakraTheme } from '../index';
import { parseHexColor } from './parse-hex-color';

export const transparentize =
  (color: string, alpha: number) => (theme: typeof chakraTheme) => {
    const [hexColor] = getToken('colors', [color])(theme);
    const { r, g, b } = parseHexColor(hexColor);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };
